import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PipesModule } from '../../../core/pipes/pipes.module';
import { NativeVideoPreviewComponent } from './native-video-preview.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    SkeletonModule,
    ProgressSpinnerModule,
  ],
  declarations: [NativeVideoPreviewComponent],
  exports: [NativeVideoPreviewComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NativeVideoPreviewModule {}
